import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/delivery.scss";

function Delivery() {
  const threshold = Number(siteConfig.shippingThreshold) || 200;
  const currency =
    typeof siteConfig.currency === "string"
      ? siteConfig.currency
      : siteConfig.currency?.code || "USD";
  const formattedThreshold = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(threshold);

  return (
    <main className="delivery-page">
      <header className="delivery-page__header">
        <p className="delivery-page__eyebrow">Help &amp; information</p>
        <h1>Shipping</h1>
        <p>
          We pack every {siteConfig.brandName} order with care and send tracking
          details as soon as it leaves our studio.
        </p>
      </header>

      <section className="delivery-page__notice" aria-label="Free shipping offer">
        <p>Complimentary U.S. ground shipping on orders over {formattedThreshold}.</p>
      </section>

      <section className="delivery-page__section" aria-labelledby="shipping-options-title">
        <div className="delivery-page__heading">
          <span>01</span>
          <h2 id="shipping-options-title">Shipping options</h2>
        </div>
        <div className="delivery-page__table" role="table" aria-label="Estimated shipping times">
          <div className="delivery-page__table-row delivery-page__table-head" role="row">
            <span role="columnheader">Destination</span>
            <span role="columnheader">Service</span>
            <span role="columnheader">Estimated transit</span>
          </div>
          <div className="delivery-page__table-row" role="row">
            <span role="cell">United States</span>
            <span role="cell">Ground / Express</span>
            <span role="cell">3–7 / 2–3 business days</span>
          </div>
          <div className="delivery-page__table-row" role="row">
            <span role="cell">Canada</span>
            <span role="cell">Tracked international</span>
            <span role="cell">5–10 business days</span>
          </div>
          <div className="delivery-page__table-row" role="row">
            <span role="cell">Rest of world</span>
            <span role="cell">Tracked international</span>
            <span role="cell">7–14 business days</span>
          </div>
        </div>
      </section>

      <div className="delivery-page__grid">
        <section aria-labelledby="processing-title">
          <span>02</span>
          <h2 id="processing-title">Processing</h2>
          <p>
            In-stock orders usually leave within one to two business days.
            Orders placed after 1pm ET, on weekends, or on public holidays begin
            processing the next business day.
          </p>
          <p>
            During launches and seasonal promotions, please allow an additional
            two business days. Transit estimates begin once the carrier receives
            the parcel.
          </p>
        </section>
        <section aria-labelledby="tracking-title">
          <span>03</span>
          <h2 id="tracking-title">Tracking</h2>
          <p>
            A shipping confirmation with a tracking link is emailed after your
            order is packed. Tracking may take up to 24 hours to show its first
            scan.
          </p>
          <p>
            If a parcel appears delayed or was marked delivered but cannot be
            found, contact us within seven days so we can help investigate.
          </p>
        </section>
        <section aria-labelledby="international-title">
          <span>04</span>
          <h2 id="international-title">International orders</h2>
          <p>
            Import duties, taxes, and carrier fees are set by the destination
            country and are the recipient’s responsibility unless checkout says
            otherwise. Customs processing can extend delivery estimates.
          </p>
          <p>
            We cannot mark purchases as gifts or change the declared value on
            customs documents.
          </p>
        </section>
        <section aria-labelledby="changes-title">
          <span>05</span>
          <h2 id="changes-title">Address changes</h2>
          <p>
            Contact us as soon as possible if an address needs correction. Once
            the carrier has collected an order, rerouting may not be available
            and additional fees can apply.
          </p>
        </section>
      </div>

      <section className="delivery-page__help">
        <p>Still waiting on an order?</p>
        <Link to="/contact">Contact customer care</Link>
      </section>
    </main>
  );
}

export default Delivery;
